// index.js
import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./routes/privateRoute";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import CSS
import "./App.css";
import { Box, CircularProgress } from "@mui/material";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import getRoutes from "./routes/routeConfig";

function App() {
  const { currentLang } = useAuth();
  console.log(
    "current language local storage is empty--------------->",
    currentLang
  );
  const direction = currentLang === "en" ? "ltr" : "rtl";

  useEffect(() => {
    console.log("current lang------>", currentLang);
    // LocalesConfig(currentLang);
  }, [currentLang]);
  return (
    <div dir={direction}>
      <Router>
        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          }
        >
          <Routes>
            {getRoutes().map((route, index) => {
              const Component = route.component;
              const Layout = route.layout;
              if (route.private && route.layout) {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <PrivateRoute>
                        <Layout>
                          <Component />
                        </Layout>
                      </PrivateRoute>
                    }
                  />
                );
              } else if (!route.private && route.layout) {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <Layout currentLang={currentLang}>
                        <Component currentLang={currentLang} />
                      </Layout>
                    }
                  />
                );
              } else {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={<Component />}
                  />
                );
              }
            })}
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

const Root = () => (
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <CssBaseline /> {/* Optional: Provides a consistent baseline for MUI */}
      {/* <GlobalStyles /> */}
      {/* <I18nextProvider i18n={LocalesConfig}> */}
      <App />
      <ToastContainer
        position="top-right" // Position of the toast
        autoClose={6000} // Auto close after 3 seconds
        hideProgressBar={false} // Show progress bar
        newestOnTop={true} // Newest toast appears on top
        closeOnClick // Close toast when clicked
        rtl={false} // Right-to-left support
        pauseOnFocusLoss // Pause toast when window loses focus
        draggable // Allow toast to be draggable
        pauseOnHover // Pause toast when hovered
        theme="light" // Theme of the toast (light/dark/colored)
      />
      {/* </I18nextProvider> */}
    </AuthProvider>
  </ThemeProvider>
);

export default Root;
